import { Record, List } from 'immutable';

export const PracticeEfectorVisits = new Record({
  id: null,
  isNew: true,
  isPending: false,
  items: new List(),
	updated_at: new Date(),
});

export const PracticeEfectorVisit = new Record({
  id: null,
  practicaId: null,
  efectorId: null,
  inicio: null,
  fin: null,
  latInicio: null,
  longInicio: null,
  latFin: null,
  longFin: null,
  observaciones: null,
	created_at: new Date(),
});


export function createPracticeEfectorVisit(data) {
  return new PracticeEfectorVisit({
    id: data.id,
    practicaId: data.practicaId,
    efectorId: data.efectorId,
    inicio: data.inicio,
    fin: data.fin,
    latInicio: data.latInicio,
    longInicio: data.longInicio,
    latFin: data.latFin,
    longFin: data.longFin,
    observaciones: data.observaciones,

  });
}
